export default __webpack_public_path__ + "static/media/0xd85d1e945766fea5eda9103f918bd915fbca63e6.78161d3e.webp";